import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SwishActions, SwishEpics, SwishFacade } from './+state';
import { SwishService } from './swish.service';

@NgModule( {
    imports: [
        CommonModule
    ],
    declarations: [],
    providers: [ SwishService, SwishActions, SwishEpics, SwishFacade ]
} )
export class SwishModule { }
